// components/StockAlmacen.jsx
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";
import "./StockAlmacen.css";
import { useFiscal } from '../hooks/useFiscal';

const StockAlmacen = () => {
  const fiscal = useFiscal();
  const { id } = useParams();
  const navigate = useNavigate();
  const [almacen, setAlmacen] = useState(null);
  const [stocks, setStocks] = useState([]);
  const [resumen, setResumen] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filtroProyecto, setFiltroProyecto] = useState("");

  useEffect(() => {
    cargarStock();
  }, [id, filtroProyecto]);

  const cargarStock = async () => {
    try {
      setLoading(true);
      const url = filtroProyecto 
        ? `/almacenes/${id}/stock?proyecto_id=${filtroProyecto}`
        : `/almacenes/${id}/stock`;
      
      const response = await api.get(url);
      setAlmacen(response.data.almacen);
      setStocks(response.data.stocks);
      setResumen(response.data.resumen);
    } catch (error) {
      console.error("Error al cargar stock:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatearMoneda = (valor) => {
    return new Intl.NumberFormat("es-DO", {
      style: "currency",
      currency: fiscal.moneda?.codigo || "DOP",
    }).format(valor);
  };

  if (loading) {
    return <div className="loading">Cargando stock del almacén...</div>;
  }

  if (!almacen) {
    return <div className="error">Almacén no encontrado</div>;
  }

  return (
    <div className="stock-almacen-container">
      {/* Header */}
      <div className="header">
        <div>
          <button className="btn-back" onClick={() => navigate("/almacenes")}>
            ← Volver
          </button>
          <h1>📦 Stock - {almacen.nombre}</h1>
          <p className="subtitle">
            {almacen.codigo} • {almacen.tipo === "principal" ? "🏢 Principal" : "📍 Secundario"}
          </p>
        </div>
      </div>

      {/* Resumen */}
      {resumen && (
        <div className="resumen-grid">
          <div className="resumen-card">
            <div className="resumen-icon">📦</div>
            <div className="resumen-info">
              <span className="resumen-label">Total Materiales</span>
              <span className="resumen-value">{resumen.total_materiales}</span>
            </div>
          </div>
          <div className="resumen-card">
            <div className="resumen-icon">🔢</div>
            <div className="resumen-info">
              <span className="resumen-label">Cantidad Total</span>
              <span className="resumen-value">
                {resumen.cantidad_total.toLocaleString("es-DO", {
                  minimumFractionDigits: 2,
                })}
              </span>
            </div>
          </div>
          <div className="resumen-card highlight">
            <div className="resumen-icon">💰</div>
            <div className="resumen-info">
              <span className="resumen-label">Valor Total</span>
              <span className="resumen-value">
                {formatearMoneda(resumen.valor_total)}
              </span>
            </div>
          </div>
        </div>
      )}

      {/* Tabla de Stock */}
      <div className="card">
        <div className="card-header">
          <h3>Inventario Detallado</h3>
        </div>

        <table className="tabla-stock">
          <thead>
            <tr>
              <th>Código</th>
              <th>Material</th>
              <th>Categoría</th>
              <th>Proyecto</th>
              <th>Cantidad</th>
              <th>Valor Total</th>
            </tr>
          </thead>
          <tbody>
            {stocks.map((stock) => (
              <tr key={stock.id}>
                <td>
                  <strong>{stock.material?.codigo}</strong>
                </td>
                <td>{stock.material?.nombre}</td>
                <td>
                  <span className="badge-categoria">
                    {stock.material?.categoria?.nombre || "Sin categoría"}
                  </span>
                </td>
                <td>
                  {stock.proyecto ? (
                    <span className="badge-proyecto">
                      🏗️ {stock.proyecto.nombre}
                    </span>
                  ) : (
                    <span className="badge-sin-proyecto">Sin asignar</span>
                  )}
                </td>
                <td className="cantidad">
                  {parseFloat(stock.cantidad_disponible).toLocaleString("es-DO", {
                    minimumFractionDigits: 2,
                  })}
                </td>
                <td className="valor">
                  {formatearMoneda(stock.valor_inventario)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {stocks.length === 0 && (
          <div className="empty-state">
            <p>No hay materiales en este almacén</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default StockAlmacen;